/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_OverlapInputs */



/**
* | output |
* | --- |
* | "Overlapping events" |
*
* @param {Qc_Fix_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_overlap = /** @type {((inputs?: Qc_Fix_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements qui se chevauchent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappende Events")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi sovrapposti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перекрывающиеся события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos superpuestos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの重なり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैपिंग इवेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos sobrepostos")
	return /** @type {LocalizedString} */ ("Overlapping events")
});